import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('landing-page');
  this.route('list');
  this.route('room', {
    path: ':room_id'
  });
  this.route('settings', function () {
    this.route('calendars');
    this.route('permissions');
  });
});